import dayjs, { Dayjs } from 'dayjs';

export const getDateRangeEnd = (date: Dayjs): Dayjs => {
  return date === null ? dayjs() : date;
};